import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  limit_tickets: {
    count: 0,
    data: [],
    num_pages: 1,
    page: 1,
    page_size: "5",
  },
};

const slice = createSlice({
  name: "limitticket",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LIMIT TICKET
    getLimitTicketSuccess(state, action) {
      state.isLoading = false;
      state.limit_tickets = action.payload;
    },

    // ADD LIMIT TICKET
    addLimitTicketSuccess(state, action) {
      const limitticket = action.payload;
      state.limit_tickets.data.push(limitticket);
      state.limit_tickets.count += 1;
    },

    // UPDATE LIMIT TICKETS
    updateLimitTicketSuccess(state, action) {
      const limitticket = action.payload;
      if (state.limit_tickets && state.limit_tickets.data) {
        const limitticketIndex = state.limit_tickets?.data?.findIndex(
          (obj) => obj.id === limitticket.id
        );
        if (limitticketIndex !== -1) {
          state.isLoading = false;
          state.limit_tickets.data[limitticketIndex] = limitticket;
        }
      } else {
        state.limit_tickets = { data: [] };
        state.limit_tickets.data.push(limitticket);
      }
    },

    // DELETE LIMIT TICKET
    deleteLimitTicketSuccess(state, action) {
      const deletedLimitTicketId = action.payload;
      state.limit_tickets.data = state.limit_tickets.data.filter(
        (limitticket) => limitticket.id !== deletedLimitTicketId
      );
      state.isLoading = false;
    },

    // DELETE LIMIT TICKETS
    deleteLimitTicketsSuccess(state, action) {
      const deletedLimitTicketIds = action.payload;
      state.limit_tickets.data = state.limit_tickets.data.filter(
        (limitticket) => !deletedLimitTicketIds.includes(limitticket.id)
      );
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addLimitTicketSuccess,
  updateLimitTicketSuccess,
  deleteLimitTicketSuccess,
  deleteLimitTicketsSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function getLimitTickets(page = 1, rowsPerPage = 5) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard/limit-ticket?page=${page}&page_size=${rowsPerPage}`
      );
      dispatch(slice.actions.getLimitTicketSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getLimitTicket(keyId) {
  const response = await axios.get(
    `/api/dashboard/limit-ticket-id?keyId=${keyId}`
  );
  return response.data;
}

export async function addLimitTicket(data) {
  const response = await axios.post(`/api/dashboard/limit-ticket`, data);
  return response.data;
}

export async function updateLimitTicket(data) {
  const response = await axios.put(`/api/dashboard/limit-ticket`, data);
  return response.data;
}

export async function deleteLimitTicket(keyId) {
  const response = await axios.delete(`/api/dashboard/limit-ticket/${keyId}/`);
  return response.data;
}

export async function deleteLimitTickets(keyIds) {
  const response = await axios.delete(`/api/dashboard/limit-ticket-id`, {
    data: { keyIds },
  });
  return response.data;
}
